import React from 'react';

const Table = ({ data }) => {
  if (!data) return null;

  return (
    <div className="my-6 overflow-x-auto">
      {data.title && <h3 className="text-xl font-bold mb-2">{data.title}</h3>}
      <table className="w-full border-collapse text-left">
        {/* Rendert eine Kopfzeile, falls in den Daten vorhanden */}
        {data.headers && (
          <thead>
            <tr className="bg-gray-100">
              {data.headers.map((header, i) => (
                <th key={i} className="border border-gray-400 p-2 font-bold text-right first:text-left">{header}</th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {data.rows.map((row, index) => (
            <tr key={index} className={row.highlight || ''}>
              
              {/* Fall 1: Eine Zeile mit einem Array von Zellen (für die 3-spaltige Tabelle) */}
              {row.cells ? (
                row.cells.map((cell, i) => (
                  <td key={i} className={`border border-gray-400 p-2 text-right first:text-left ${row.isBold ? 'font-bold' : ''}`}>
                    {cell}
                  </td>
                ))
              ) : 
              
              /* Fall 2: Eine Zeile, die Spalten überspannt (für die "Überschuss"-Zeile) */
              row.span ? (
                <>
                  <td className={`border border-gray-400 p-2 ${row.isBold ? 'font-bold' : ''}`} colSpan="2">{row.label}</td>
                  <td className={`border border-gray-400 p-2 text-right ${row.isBold ? 'font-bold' : ''}`}>{row.value}</td>
                </>
              ) :
              
              /* Fall 3: Eine einzelne Überschrift, die alle Spalten überspannt (für 2-spaltige Tabellenköpfe) */
              row.header ? (
                 <th className="border border-gray-400 p-2 font-bold" colSpan="2">{row.header}</th>
              ) :
              
              /* Fall 4: Ein einfaches Label/Wert-Paar (für 2-spaltige Tabellenzeilen) */
              (
                <>
                  <td className={`border border-gray-400 p-2 ${row.indent ? 'pl-8' : ''} ${row.isBold ? 'font-bold' : ''}`}>
                    {row.label}
                  </td>
                  <td className={`border border-gray-400 p-2 text-right ${row.isBold ? 'font-bold' : ''}`}>
                    {row.value}
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;